import { render, staticRenderFns } from "./OrganizationSelect.vue?vue&type=template&id=9d798b38"
import script from "./OrganizationSelect.ts?vue&type=script&lang=ts&external"
export * from "./OrganizationSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports